import { Icon, typography } from '@toggle/design-system';
import styled from 'styled-components';

export const Market = styled.div<{ $marketOpen: boolean }>`
  display: flex;
  align-items: center;
  ${typography.quokka}
  color: ${({ $marketOpen }) =>
    $marketOpen ? 'var(--success--default)' : 'var(--text-disabled)'};
`;

export const DotIcon = styled(Icon)<{ $marketOpen: boolean }>`
  fill: ${({ $marketOpen }) =>
    $marketOpen ? 'var(--success--default)' : 'var(--icon-disabled)'};
  margin-right: 8px;
`;
